// extracted by mini-css-extract-plugin
module.exports = {"result-wrap":"result_result-wrap__yQy43"};